import servise from '@/router/axios'

export const hot = (data) => {
    return servise({
      url: '/uporder/on/the/order',
      method: 'PUT',
      data
    })
  }